import { defineMessages } from 'react-intl-next';

export const messages: {
	personAvatarLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	personAvatarLabel: {
		id: 'search-page.profile-avatar.label',
		defaultMessage: 'Person Avatar',
		description: 'Default person avatar icon for users',
	},
});
